import { provide } from 'vue'
import { VALIDATION_RULES_KEY, type AppValidationRules } from '@jms/utils'
import { lang } from '@jms/utils'

export function useValidationProvider() {
  const rules: AppValidationRules = {
    phone: [
      { required: true, message: lang('请输入') },
      { pattern: /^(?:0|62|\+62|60|\+60)[0-9]{7,14}$/, message: lang('+62/0/62/+60/60 开头,只允许输入 8 - 16 位') }
    ]
  }
  provide(VALIDATION_RULES_KEY, rules)
}
